import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getViewPartner, VIEW_PARTNER_EVENT } from "../utils/partnerApi";

/**
 * Access levels (KOL_CAMPAIGNS_AGENCY_PLAN.md §7.1):
 *   partner — integrator (API / widget), today's menu
 *   kol     — creator: campaigns + stats + points, developer tools hidden
 *   agency  — monitors linked KOLs read-only
 * ppapi returns `accountType` in the login / isLogin response; older
 * backends omit it → partner.
 */
export const ACCOUNT_TYPES = ["partner", "kol", "agency"];

export function normalizeAccountType(v) {
  const s = String(v || "").toLowerCase();
  return ACCOUNT_TYPES.includes(s) ? s : "partner";
}

export function useAccountType() {
  const raw = useSelector((state) => state.userReducer.user?.response?.accountType);
  return normalizeAccountType(raw);
}

/** The partner an AGENCY is currently viewing (null = own account). Reactive. */
export function useAgencyView() {
  const [view, setView] = useState(() => getViewPartner());
  useEffect(() => {
    const onChange = () => setView(getViewPartner());
    window.addEventListener(VIEW_PARTNER_EVENT, onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener(VIEW_PARTNER_EVENT, onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);
  return view;
}
